/**
 * Session Suite côté FacturX — lecture / écriture de l’id, rien d’autre.
 * La vérif (sso-verify + ping) vit dans initFacturxSuiteAuth.ts.
 * La fenêtre du hub 2 ne lit pas cet id : facturxHub2.ts.
 */
import { isFacturxHub2Desk } from "./facturxHub2";

export const SESSION_ERRORS = new Set([
  "session_required",
  "session_or_userid_required",
  "unauthorized",
]);

/** PWA standalone `factures.app` — DocumentRoot = front/dist. */
export function isFacturxStandaloneHost(): boolean {
  const host = String(window.location.hostname || "").toLowerCase();
  return host === "factures.app.aureliasuite.fr" || host.endsWith(".factures.app.aureliasuite.fr");
}

/** Origine Suite (auth.app = document root `suite/`). */
export function getSuiteBasePath(): string {
  if (isFacturxStandaloneHost()) return "";
  let raw = window.location.pathname || "/";
  if (raw.endsWith("/index.html")) {
    raw = raw.slice(0, -"/index.html".length) || "/";
  }
  const idx = raw.toLowerCase().indexOf("/facturx");
  const p = (idx >= 0 ? raw.slice(0, idx) : raw).replace(/\/+$/u, "");
  return p === "/" ? "" : p;
}

export function getSuiteApiBase(): string {
  return `${getSuiteBasePath()}/api_suite`;
}

export function getFacturxApiBase(): string {
  return `${getSuiteBasePath()}/facturx/api`;
}

export function getWhoamiUrl(): string {
  return `${getSuiteApiBase()}/session/whoami.php`;
}

export function isEmbeddedInHub(): boolean {
  try {
    return window.parent !== window;
  } catch {
    return false;
  }
}

export function syncUserIdFromQuery(): string | null {
  if (isFacturxHub2Desk()) return null;
  try {
    const q = new URLSearchParams(window.location.search);
    const v = q.get("suite_user_id") || q.get("userId");
    if (v && /^\d+$/.test(v)) {
      sessionStorage.setItem("suite_user_id", v);
      localStorage.setItem("suite_user_id", v);
      localStorage.setItem("userId", v);
      window.dispatchEvent(new CustomEvent("suiteUserIdReceived", { detail: { userId: v } }));
      return v;
    }
  } catch {
    /* ignore */
  }
  return null;
}

export function readUserId(): string {
  if (isFacturxHub2Desk()) {
    const memory = window.__facturxHub2UserId ? String(window.__facturxHub2UserId) : "";
    if (/^\d+$/.test(memory) && Number(memory) > 0) return memory;
    try {
      const params = new URLSearchParams(window.location.search);
      const fromDesk = params.get("suite_user_id") || params.get("userId") || "";
      if (/^\d+$/.test(fromDesk) && Number(fromDesk) > 0) return fromDesk;
    } catch {
      /* adresse illisible */
    }
    return "";
  }
  const fromShared = window.readStoredSuiteUserId?.();
  if (fromShared != null && String(fromShared) !== "") return String(fromShared);
  try {
    const local = localStorage.getItem("suite_user_id") || localStorage.getItem("userId");
    if (!local || !/^\d+$/.test(local)) return "";
    return local;
  } catch {
    return "";
  }
}
